import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import CRM from "@/pages/CRM";
import RecordsView from "@/components/records/RecordsView";
import { cached, remember } from "@/lib/cache";

export default function ModulePage() {
  const { key } = useParams();
  const [mods, setMods] = useState(cached("crm_modules") || null);
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/crm/modules").then((r) => setMods(remember("crm_modules", r.data.rows))); }, [key]);
  useEffect(() => {
    setStats(null);
    if (key === "dq") { setStats({ total: 0, leads: 1 }); return; }
    api.get(`/crm/modules/${key}/record-stats`).then((r) => setStats(r.data)).catch(() => setStats({ total: 0, leads: 1 }));
  }, [key]);
  const mod = (mods || []).find((x) => x._id === key);
  if (!mods || !stats) return <div className="p-6 text-xs text-[var(--text-faint)]" data-testid="module-loading">Loading…</div>;
  if (!mod) return <div className="p-6 text-sm text-[var(--text-dim)]" data-testid="module-missing">Module not found.</div>;
  const mode = mod?.holds && mod.holds !== "auto" ? mod.holds : null;
  if (mode === "records" || (!mode && (stats.total > 0 || !stats.leads))) return <RecordsView key={key} mod={mod} total0={stats.total} />;
  return <CRM key={key} module={key} title={mod.name} extraFields={mod.fields || []} />;
}
